import {
    GET_LITERALS_REQUEST,
    GET_LITERALS_SUCCESS,
    GET_LITERALS_ERROR,
} from 'constants/ActionTypes';

// import { Core } from 'managers';

// let defaultState;

const initialState = {
    loading: false,
    error: false,
    literals: {},
};

/* function initState(initStateData) {
  if (!defaultState) {
    debugger;
    const initialStateCache = Core.cacheManager.getLiteralsStore();
    if (initialStateCache) {
      defaultState = {
        ...initStateData,
        literals: initialStateCache,
      };
    } else {
      defaultState = initStateData;
    }
  }
  return defaultState;
} */

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_LITERALS_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case GET_LITERALS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                literals: action.payload,
            };
        case GET_LITERALS_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
}
